<template>
    <div>

        <div v-if="advancedEmailOptions == 1 && (pieceName=='from_name' || pieceName=='from_email' || pieceName=='reply_email')">
            <!--TEXT : It's a one line text input.-->

            <label v-if="pieceName=='from_name'" class="control-label">From Name</label>
            <label v-if="pieceName=='from_email'" class="control-label">From Email</label>
            <label v-if="pieceName=='reply_email'" class="control-label">Reply Email</label>

            <textarea type="text" :class="'form-control '  + pieceName" :name="'pieces[' + pieceIndex + '][content]'" class="messagearea step-messagearea one-line-input">{{ stripSlashes(pieceContent) }}</textarea>
            <div class="step-spacer"></div>
        </div>

        <div v-else>
            <!--HIDDEN : It's a hidden input field.-->
            <input type="hidden" :class="'form-control ' + pieceName" :name="'pieces[' + pieceIndex + '][content]'" :value="stripSlashes(pieceContent)">
        </div>

    </div>
</template>

<script>

    import utils from "../../../../mixins/utils";

    export default {
        name: 'hidden-piece',
        mixins: [utils],
        data() {
            return {
            };
        },
        props: {
            advancedEmailOptions: {
                type: Boolean,
                required:true
            },
            pieceIndex: {
                type: Number,
                required:true
            },
            pieceName: {
                type: String,
                required:true
            },
            pieceContent: {
                type: String,
                required:true
            }
        }
    }
</script>

<style lang="scss">

</style>